import { ProxyGraphClients, abgGraphqlClient as graphqlClient } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { fetchLinkedEntitlementsForCollectionOptOutTrial } from './queries/fetch-linked-entitlements-collection-opt-out';

export async function getLinkedEntitlementsForCollectionOptOutTrial(
  entitlementId: string,
  transactionAccountId: string
) {
  const response = await graphqlClient(ProxyGraphClients.ANS).query<
    generatedTypesNew.FetchLinkedEntitlementsPpcQuery,
    generatedTypesNew.FetchLinkedEntitlementsPpcQueryVariables
  >({
    query: fetchLinkedEntitlementsForCollectionOptOutTrial,
    variables: {
      id: entitlementId,
      searchLinkedEntitlementParams: {
        entitlementId,
        containerId: null,
        currentEntitlementType: generatedTypesNew.LinkedEntitlementTypes.COLLECTION_PRODUCT,
        destinationEntitlementType: [generatedTypesNew.LinkedEntitlementTypes.COLLECTION_INSTANCE],
        productType: generatedTypesNew.LinkedProductTypes.OTHER,
        findProducts: true,
        findApps: false,
      },
      transactionAccountId,
    },
    fetchPolicy: 'cache-first',
  });

  return response;
}
